import PropTypes from "prop-types";

import TableItem from "../../../ui/TableItem";
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  analysisTypePropType,
  intersectionsPropType,
} from "../../../util/propTypeHelper";
import CostWithPeriodField from "./CostWithPeriodField";
import { OPERATIONS_MAINTENANCE_TYPES } from "./operationsAndMaintenanceHelper";

export default function OperationsAndMaintenanceForm({
  analysisType,
  defaultValues,
  errors,
  formData,
  intersections,
  register,
}) {
  return (
    <TableContainer component={Paper} sx={{ marginTop: "30px" }}>
      <Table
        sx={{ minWidth: 650 }}
        aria-label="construction and maintenence costs table"
      >
        <TableHead>
          <TableRow>
            {[
              "Intersection",
              "LED and UPS Replacement",
              "Lighting Lease",
              "Lighting",
              "Power",
              "Pushbutton/APS/Detection Replacement",
              "Roundabout Landscaping",
              "Signal Controller Replacement",
              "Signal Maintenance",
              "Signal Retiming",
              "Other",
              "Other 2",
            ].map((title) => (
              <TableItem key={title} header size="small">
                {title}
              </TableItem>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {intersections.map(({ id, type, uniqueName }) => {
            const defaultValuesOM = defaultValues[id] ?? {};
            const globalConstantsOM =
              window.PENN_DOT_CONSTANTS.OPERATIONS_MAINTENANCE_COSTS[
                analysisType
              ][type];

            return (
              <TableRow key={id}>
                <TableItem size="small">{uniqueName}</TableItem>
                {OPERATIONS_MAINTENANCE_TYPES.map(
                  ({ constantsKey, isAlwaysShown, storageKey }) => {
                    const globalConstants = globalConstantsOM[constantsKey];
                    const userSavedValues = defaultValuesOM[storageKey];
                    const getName = (fieldName) =>
                      `${id}.${storageKey}.${fieldName}`;
                    // global defaults do not incorporate user saved values
                    const globalCostDefault = globalConstants?.cost ?? 0;
                    const globalPeriodDefault =
                      globalConstants?.periodYears ?? 1;
                    return (
                      <TableItem key={storageKey} size="small">
                        {(!!globalConstants || isAlwaysShown) && (
                          <CostWithPeriodField
                            costDefaultValue={
                              userSavedValues?.cost ?? globalCostDefault
                            }
                            globalCostDefault={globalCostDefault}
                            currentCostValue={formData[id]?.[storageKey]?.cost}
                            costFieldName={getName("cost")}
                            errors={errors}
                            periodDefaultValue={
                              userSavedValues?.periodYears ??
                              globalPeriodDefault
                            }
                            globalPeriodDefault={globalPeriodDefault}
                            currentPeriodValue={
                              formData[id]?.[storageKey]?.periodYears
                            }
                            periodFieldName={getName("periodYears")}
                            register={register}
                          />
                        )}
                      </TableItem>
                    );
                  }
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

OperationsAndMaintenanceForm.propTypes = {
  analysisType: analysisTypePropType,
  defaultValues: PropTypes.object,
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  intersections: intersectionsPropType,
  register: PropTypes.func.isRequired,
};
